import CrimeObject from "../model/CrimeObject";

const key_subject_config: string = 'subject_config';


export type Unit = {
    readonly id: string,
    readonly title: string
}


class SubjectConfig {
    generated: string = "01.01.2017 00:00:00";
    units: Unit[] = [];
    objects: CrimeObject[] = [];

    // constructor(generated: string, units: Unit[], objects: CrimeObject[]) {
    //     this.generated = generated;
    //     this.units = units;
    //     this.objects = objects;
    // }

    /**
    * Возвращает конфигурацию из локального хранилища
    */
    static getLocal(): SubjectConfig {
        let cfg = localStorage.getItem(key_subject_config);
        if (cfg !== null) {
            return JSON.parse(cfg) as SubjectConfig
        }
        return new SubjectConfig();
    }

    /**
     * Сохраняет в локальном хранилище конфигурацию филиала
     * @param cfg Объект SubjectConfig для сохранения
     */
    static saveLocal(cfg: SubjectConfig): void {
        localStorage.setItem(key_subject_config, JSON.stringify(cfg))
        console.info("local SubjectConfig updated")
    }
}

export default SubjectConfig;